<div>
    <app-nav></app-nav>
    <section>
        <router-outlet></router-outlet>
    </section>
    <app-footer></app-footer>
</div>
